import { render, staticRenderFns } from "./ProductgrouppagePage.vue?vue&type=template&id=21005f28"
import script from "./ProductgrouppagePage.vue?vue&type=script&lang=js"
export * from "./ProductgrouppagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports